import React from "react";
import { MapPin, Clock, Phone, Facebook, Instagram, Youtube } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-[#FFF8F6] via-[#FFF5F2] to-[#FFF8F6] border-t border-[#FFD8C8]/40 py-6 px-5 relative overflow-hidden">
      {/* 🌸 Background pattern subtle */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 1L12 23M1 12L23 12' stroke='%23FF8A65' stroke-width='0.4'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
        }}
      />

      <div className="relative z-10 max-w-6xl mx-auto flex flex-col items-center text-center gap-4">
        {/* 🐐 Brand */}
        <div className="flex flex-col items-center gap-2">
          <img
            src="/Toyibah_Aqiqah.png"
            alt="Toyibah Aqiqah Logo"
            className="w-10 h-10 object-contain"
          />
          <h2 className="text-lg font-extrabold text-[#FF8A65]">Toyibah Aqiqah</h2>
          <p className="text-xs text-[#777] max-w-md leading-relaxed">
            Layanan aqiqah profesional, syar’i, dan penuh keberkahan untuk keluarga Anda.
          </p>
        </div>

        {/* 📍 Contact Info */}
        <div className="flex flex-wrap justify-center items-center gap-4 text-[#555] text-sm">
          <a
            href="https://share.google/93qNqOM1jpqlD7QrG"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:text-[#FF8A65] transition"
          >
            <MapPin className="w-4 h-4 text-[#FF8A65]" />
            <span>Depok, Jawa Barat</span>
          </a>
          <a
            href="https://wa.me/6281295138575"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:text-[#FF8A65] transition"
          >
            <Phone className="w-4 h-4 text-[#FF8A65]" />
            <span>+62 878-8424-3038</span>
          </a>
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-[#FF8A65]" />
            <span>08.00–20.00 WIB</span>
          </div>
        </div>

        {/* 🌐 Sosial Media */}
        <div className="flex justify-center gap-3">
          {[Facebook, Instagram, Youtube].map((Icon, i) => (
            <a
              key={i}
              href="#"
              className="w-8 h-8 rounded-full bg-white text-[#FF8A65] flex items-center justify-center shadow-sm hover:bg-[#FF8A65] hover:text-white transition-all duration-300"
            >
              <Icon className="w-4 h-4" />
            </a>
          ))}
        </div>

        {/* 💌 Newsletter */}
        <div className="flex items-center justify-center gap-1 max-w-xs mx-auto">
          <input
            type="email"
            placeholder="Email Anda"
            className="bg-white border border-gray-200 rounded-l-lg px-3 py-2 w-full text-sm outline-none focus:border-[#FF8A65]"
          />
          <button className="bg-[#FF8A65] text-white px-3 py-2 rounded-r-lg font-semibold text-xs hover:bg-[#FF6B4A] transition-all">
            Kirim
          </button>
        </div>

        {/* 🧡 Footer Bottom */}
        <div className="flex flex-wrap justify-center items-center gap-2 text-center text-[12px] text-[#999] pt-2 border-t border-[#FFD8C8]/30 mt-2 w-full">
          <p>© {currentYear} Toyibah Aqiqah</p>
          <span>•</span>
          <p>
            Website by{" "}
            <a
              href="https://www.linkedin.com/in/muhammad-mabrur-riyamasey-mas-ud-146069235"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#FF8A65] font-semibold hover:underline"
            >
              Mabrur RMZ
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
